import React, { useState } from "react";
import "./RoleManager.css";

function RoleManager() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="role-page">

      {/* HEADER */}
      <div className="role-top-header">

        <div>
          <h2 className="role-page-title">
            Quản lý vai trò
          </h2>

          <div className="role-breadcrumb">
            Trang chủ / Quản trị hệ thống / Quản lý vai trò / Danh sách vai trò
          </div>
        </div>

        <button
          className="role-add-btn"
          onClick={handleOpenModal}
        >
          <i className="fa-solid fa-plus"></i>
          Thêm vai trò
        </button>

      </div>

      {/* SEARCH */}
      <div className="role-search-wrapper">

        <div className="role-search-grid">

          <div>
            <label className="role-search-label">
              Tìm kiếm
            </label>

            <div className="role-input-wrap">

              <input
                type="text"
                placeholder="Nhập tên vai trò..."
                className="role-search-input"
              />

              <i className="fa-solid fa-magnifying-glass role-input-icon"></i>

            </div>
          </div>

          <div>
            <label className="role-search-label">
              Trạng thái
            </label>

            <select className="role-search-select">
              <option>-- Tất cả --</option>
            </select>
          </div>

          <div>
            <label className="role-search-label">
              Mô tả
            </label>

            <input
              type="text"
              placeholder="Nhập mô tả..."
              className="role-search-input"
            />
          </div>

          <div className="role-search-action">

            <button className="role-reset-btn">
              <i className="fa-solid fa-rotate-left"></i>
              Đặt lại
            </button>

            <button className="role-submit-btn">
              <i className="fa-solid fa-magnifying-glass"></i>
              Tìm kiếm
            </button>

          </div>

        </div>

      </div>

      {/* MAIN */}
      <div className="role-main-grid">

{/* LEFT */}
<div className="role-left-card">

  {/* HEADER */}
  <div className="role-card-header">

    <h3>Danh sách vai trò</h3>

    <button className="role-refresh-btn">
      <i className="fa-solid fa-rotate-right"></i>
    </button>

  </div>

  {/* TABLE */}
  <div className="role-table-wrapper">

    <table className="role-table">

      <thead>

        <tr>
          <th>STT</th>
          <th>Tên vai trò</th>
          <th>Mô tả</th>
          <th>Số người dùng</th>
          <th>Trạng thái</th>
          <th>Thao tác</th>
        </tr>

      </thead>

      <tbody>

        {/* ROW 1 */}
        <tr>

          <td>1</td>

          <td>
            <strong>Quản trị hệ thống</strong>
          </td>

          <td>Toàn quyền hệ thống</td>

          <td className="text-center">
            3
          </td>

          <td>
            <span className="status-active">
              Hoạt động
            </span>
          </td>

          <td>

            <div className="role-action-group">

              <button className="role-action-btn">
                <i className="fa-regular fa-eye"></i>
              </button>

              <button className="role-action-btn">
                <i className="fa-solid fa-pen"></i>
              </button>

              <button className="role-action-btn delete-btn">
                <i className="fa-regular fa-trash-can"></i>
              </button>

            </div>

          </td>

        </tr>

        {/* ROW 2 */}
        <tr>

          <td>2</td>

          <td>
            <strong>Lãnh đạo Sở</strong>
          </td>

          <td>Xem báo cáo, phê duyệt</td>

          <td className="text-center">
            8
          </td>

          <td>
            <span className="status-active">
              Hoạt động
            </span>
          </td>

          <td>

            <div className="role-action-group">

              <button className="role-action-btn">
                <i className="fa-regular fa-eye"></i>
              </button>

              <button className="role-action-btn">
                <i className="fa-solid fa-pen"></i>
              </button>

              <button className="role-action-btn delete-btn">
                <i className="fa-regular fa-trash-can"></i>
              </button>

            </div>

          </td>

        </tr>

        {/* ROW ACTIVE */}
        <tr className="active-row">

          <td>3</td>

          <td>
            <strong>Cán bộ nghiệp vụ</strong>
          </td>

          <td>Nhập liệu, xử lý dữ liệu</td>

          <td className="text-center">
            156
          </td>

          <td>
            <span className="status-active">
              Hoạt động
            </span>
          </td>

          <td>

            <div className="role-action-group">

              <button className="role-action-btn">
                <i className="fa-regular fa-eye"></i>
              </button>

              <button className="role-action-btn">
                <i className="fa-solid fa-pen"></i>
              </button>

              <button className="role-action-btn delete-btn">
                <i className="fa-regular fa-trash-can"></i>
              </button>

            </div>

          </td>

        </tr>

        {/* ROW 4 */}
        <tr>

          <td>4</td>

          <td>
            <strong>Cán bộ thẩm định</strong>
          </td>

          <td>Thẩm định hồ sơ, báo cáo</td>

          <td className="text-center">
            24
          </td>

          <td>
            <span className="status-active">
              Hoạt động
            </span>
          </td>

          <td>

            <div className="role-action-group">

              <button className="role-action-btn">
                <i className="fa-regular fa-eye"></i>
              </button>

              <button className="role-action-btn">
                <i className="fa-solid fa-pen"></i>
              </button>

              <button className="role-action-btn delete-btn">
                <i className="fa-regular fa-trash-can"></i>
              </button>

            </div>

          </td>

        </tr>

        {/* ROW 5 */}
        <tr>

          <td>5</td>

          <td>
            <strong>Doanh nghiệp</strong>
          </td>

          <td>Kê khai, nộp hồ sơ</td>

          <td className="text-center">
            213
          </td>

          <td>
            <span className="status-active">
              Hoạt động
            </span>
          </td>

          <td>

            <div className="role-action-group">

              <button className="role-action-btn">
                <i className="fa-regular fa-eye"></i>
              </button>

              <button className="role-action-btn">
                <i className="fa-solid fa-pen"></i>
              </button>

              <button className="role-action-btn delete-btn">
                <i className="fa-regular fa-trash-can"></i>
              </button>

            </div>

          </td>

        </tr>

        {/* ROW 6 */}
        <tr>

          <td>6</td>

          <td>
            <strong>Khách/Đối tác</strong>
          </td>

          <td>Chỉ xem thông tin công khai</td>

          <td className="text-center">
            18
          </td>

          <td>
            <span className="status-inactive">
              Không hoạt động
            </span>
          </td>

          <td>

            <div className="role-action-group">

              <button className="role-action-btn">
                <i className="fa-regular fa-eye"></i>
              </button>

              <button className="role-action-btn">
                <i className="fa-solid fa-pen"></i>
              </button>

              <button className="role-action-btn delete-btn">
                <i className="fa-regular fa-trash-can"></i>
              </button>

            </div>

          </td>

        </tr>

      </tbody>

    </table>

  </div>

  {/* PAGINATION */}
  <div className="role-pagination">

    <div className="role-pagination-left">

      Hiển thị

      <select>
        <option>10</option>
      </select>

      dòng trên mỗi trang

    </div>

    <div className="role-pagination-center">
      1 - 6 trong 6
    </div>

    <div className="role-pagination-right">

      <button>
        <i className="fa-solid fa-angle-left"></i>
      </button>

      <button className="active">
        1
      </button>

      <button>
        <i className="fa-solid fa-angle-right"></i>
      </button>

    </div>

  </div>

</div>

        {/* RIGHT */}
        <div className="role-right-card">

          <div className="role-detail-header">
            Chi tiết vai trò: Cán bộ nghiệp vụ
          </div>

          {/* TABS */}
          <div className="role-tabs">

            <button>
              Thông tin chung
            </button>

            <button className="active">
              Phân quyền
            </button>

            <button>
              Người dùng (156)
            </button>

            <button>
              Nhật ký thay đổi
            </button>

          </div>

          {/* INFO */}
          <div className="role-info-box">

            <div>
              <div className="info-label">
                Tên vai trò
              </div>

              <div className="info-value">
                Cán bộ nghiệp vụ
              </div>

              <div className="info-label mt-16">
                Mô tả
              </div>

              <div className="info-value">
                Nhập liệu, xử lý dữ liệu nghiệp vụ
              </div>
            </div>

            <div>
              <div className="info-label">
                Trạng thái
              </div>

              <span className="status-active">
                Hoạt động
              </span>
            </div>

            <div>
              <div className="info-label">
                Ngày tạo
              </div>

              <div className="info-value">
                15/03/2024 09:30
              </div>

              <div className="info-label mt-16">
                Cập nhật lần cuối
              </div>

              <div className="info-value">
                22/05/2026 15:45
              </div>
            </div>

          </div>

          {/* MATRIX */}
          <div className="matrix-header">

            <div className="matrix-title">
              Ma trận phân quyền
            </div>

            <div className="matrix-legend">

              <div className="legend-item">
                <input type="checkbox" checked readOnly />
                <span>Toàn quyền</span>
              </div>

              <div className="legend-item">
                <input type="checkbox" checked readOnly />
                <span>Có quyền</span>
              </div>

              <div className="legend-item">
                <input type="checkbox" readOnly />
                <span>Không có quyền</span>
              </div>

              <div className="legend-item">
                <input type="checkbox" disabled />
                <span>Kế thừa</span>
              </div>

            </div>

          </div>

{/* PERMISSION TABLE */}
<div className="permission-table-wrapper">

  <table className="permission-table">

    <thead>

      <tr>
        <th rowSpan="2" className="function-col">
          Chức năng
        </th>

        <th colSpan="7" className="permission-title">
          Quyền hạn
        </th>
      </tr>

      <tr>
        <th>Xem</th>
        <th>Thêm</th>
        <th>Sửa</th>
        <th>Xóa</th>
        <th>Xuất dữ liệu</th>
        <th>In</th>
        <th>Duyệt</th>
      </tr>

    </thead>

    <tbody>

      {/* DASHBOARD */}
      <tr className="group-row">
        <td>▼ Dashboard</td>
        <td colSpan="7"></td>
      </tr>

      <tr>
        <td className="child-row">Tổng quan</td>

        <td><input type="checkbox" checked readOnly /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
      </tr>

      {/* DOANH NGHIỆP */}
      <tr className="group-row">
        <td>▼ Doanh nghiệp</td>
        <td colSpan="7"></td>
      </tr>

      <tr>
        <td className="child-row">
          Danh sách doanh nghiệp
        </td>

        <td><input type="checkbox" checked readOnly /></td>
        <td><input type="checkbox" checked readOnly /></td>
        <td><input type="checkbox" checked readOnly /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" checked readOnly /></td>
        <td><input type="checkbox" checked readOnly /></td>
        <td><input type="checkbox" disabled /></td>
      </tr>

      <tr>
        <td className="child-row">
          Thêm doanh nghiệp
        </td>

        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" checked readOnly /></td>
        <td><input type="checkbox" checked readOnly /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
      </tr>

      <tr>
        <td className="child-row">
          Cập nhật doanh nghiệp
        </td>

        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" checked readOnly /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
      </tr>

      {/* BÁO CÁO */}
      <tr className="group-row">
        <td>▼ Báo cáo</td>
        <td colSpan="7"></td>
      </tr>

      <tr>
        <td className="child-row">
          Báo cáo tổng hợp
        </td>

        <td><input type="checkbox" checked readOnly /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" checked readOnly /></td>
        <td><input type="checkbox" checked readOnly /></td>
        <td><input type="checkbox" disabled /></td>
      </tr>

      <tr>
        <td className="child-row">
          Báo cáo chi tiết
        </td>

        <td><input type="checkbox" checked readOnly /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" checked readOnly /></td>
        <td><input type="checkbox" checked readOnly /></td>
        <td><input type="checkbox" disabled /></td>
      </tr>

      <tr>
        <td className="child-row">
          Xuất báo cáo
        </td>

        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" checked readOnly /></td>
        <td><input type="checkbox" disabled /></td>
        <td><input type="checkbox" disabled /></td>
      </tr>

      {/* KÊ KHAI */}
      <tr className="group-row">
        <td>▶ Kê khai</td>
        <td colSpan="7"></td>
      </tr>

      {/* QUẢN LÝ DỮ LIỆU */}
      <tr className="group-row">
        <td>▶ Quản lý dữ liệu</td>
        <td colSpan="7"></td>
      </tr>

    </tbody>

  </table>

</div>

          <div className="role-footer-btn">

            <button className="role-edit-btn">

              <i className="fa-solid fa-lock"></i>

              Chỉnh sửa phân quyền

            </button>

          </div>

        </div>

      </div>

{/* MODAL */}
{isModalOpen && (
  <div className="role-modal-overlay">

    <div className="role-modal">

      {/* HEADER */}
      <div className="role-modal-header">

        <h2>Thêm vai trò</h2>

        <button
          className="role-close-btn"
          onClick={handleCloseModal}
        >
          ×
        </button>

      </div>

      {/* BODY */}
      <div className="role-modal-body">

        {/* SECTION */}
        <div className="modal-section">

          <div className="section-title">
            Thông tin vai trò
          </div>

          <div className="role-form-grid">

            {/* LEFT */}
            <div>

              <label className="form-label">
                Tên vai trò <span>*</span>
              </label>

              <input
                type="text"
                className="role-input"
                placeholder="Nhập tên vai trò"
              />

              {/* STATUS */}
              <div className="status-wrapper">

                <div className="form-label">
                  Trạng thái
                </div>

                <div className="radio-group">

                  <label className="radio-item">

                    <input
                      type="radio"
                      name="status"
                      defaultChecked
                    />

                    Hoạt động

                  </label>

                  <label className="radio-item">

                    <input
                      type="radio"
                      name="status"
                    />

                    Không hoạt động

                  </label>

                </div>

              </div>

            </div>

            {/* RIGHT */}
            <div>

              <label className="form-label">
                Mô tả
              </label>

              <textarea
                className="role-textarea"
                placeholder="Nhập mô tả vai trò"
              ></textarea>

            </div>

          </div>

        </div>

        {/* PERMISSION */}
        <div className="modal-section">

          <div className="section-title">
            Phân quyền
          </div>

          {/* TAB */}
          <div className="permission-tabs">

            <button className="permission-tab active">
              Phân quyền chức năng
            </button>

            <button className="permission-tab">
              Phân quyền dữ liệu
            </button>

          </div>

          {/* TABLE */}
          <div className="permission-box">

            {/* LEFT */}
            <div className="permission-left">

              <div className="permission-search">

                <input
                  type="text"
                  placeholder="Tìm kiếm chức năng..."
                />

                <i className="fa-solid fa-magnifying-glass"></i>

              </div>

              <div className="function-tree">

                <label className="tree-item bold">
                  <input type="checkbox" defaultChecked />
                  Tất cả chức năng
                </label>

                <label className="tree-item bold">
                  <input type="checkbox" defaultChecked />
                  ▼ Dashboard
                </label>

                <label className="tree-item child">
                  <input type="checkbox" defaultChecked />
                  Tổng quan
                </label>

                <label className="tree-item child">
                  <input type="checkbox" defaultChecked />
                  Thống kê
                </label>

                <label className="tree-item bold">
                  <input type="checkbox" defaultChecked />
                  ▼ Doanh nghiệp
                </label>

                <label className="tree-item child">
                  <input type="checkbox" defaultChecked />
                  Danh sách doanh nghiệp
                </label>

                <label className="tree-item child">
                  <input type="checkbox" defaultChecked />
                  Thêm doanh nghiệp
                </label>

                <label className="tree-item child">
                  <input type="checkbox" />
                  Cập nhật doanh nghiệp
                </label>

                <label className="tree-item child">
                  <input type="checkbox" />
                  Xóa doanh nghiệp
                </label>

                <label className="tree-item bold">
                  <input type="checkbox" defaultChecked />
                  ▼ Báo cáo
                </label>

                <label className="tree-item child">
                  <input type="checkbox" defaultChecked />
                  Báo cáo tổng hợp
                </label>

                <label className="tree-item child">
                  <input type="checkbox" defaultChecked />
                  Báo cáo chi tiết
                </label>

              </div>

            </div>

            {/* RIGHT */}
            <div className="permission-right">

              <table className="modal-permission-table">

                <thead>

                  <tr>
                    <th>Xem</th>
                    <th>Thêm</th>
                    <th>Sửa</th>
                    <th>Xóa</th>
                    <th>Xuất dữ liệu</th>
                    <th>In</th>
                    <th>Duyệt</th>
                  </tr>

                </thead>

                <tbody>

                  <tr>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                  </tr>

                  <tr>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                  </tr>

                  <tr>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                  </tr>

                  <tr>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                  </tr>

                  <tr>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                  </tr>

                  <tr>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                  </tr>

                  <tr>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                  </tr>

                  <tr>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                  </tr>

                  <tr>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                  </tr>

                  <tr>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" disabled /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><input type="checkbox" checked readOnly /></td>
                  </tr>

                </tbody>

              </table>

            </div>

          </div>

        </div>

      </div>

      {/* FOOTER */}
      <div className="role-modal-footer">

        <button
          className="cancel-btn"
          onClick={handleCloseModal}
        >
          Hủy bỏ
        </button>

        <button className="save-btn">
          <i className="fa-solid fa-lock"></i>
          Lưu vai trò
        </button>

      </div>

    </div>

  </div>
)}

    </div>
  );
}

export default RoleManager;